import type { QueryClientConfig } from '@tanstack/react-query';

export const ReactQueryOptions: QueryClientConfig = { defaultOptions: { queries: { refetchInterval: 90 * 1000 } } };
